import { render, staticRenderFns } from "./PerPosTrxTypeFeeReductionRewardEditor.vue?vue&type=template&id=cbd007a2&scoped=true"
import script from "./PerPosTrxTypeFeeReductionRewardEditor.vue?vue&type=script&lang=ts"
export * from "./PerPosTrxTypeFeeReductionRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbd007a2",
  null
  
)

export default component.exports